import React, {createContext} from 'react'

const ProfileContext = createContext()

export default ProfileContext;